import Environment from '@config/environment';
import Link from '@components/atoms/link/link';
import { useTranslation } from 'next-i18next';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import styles from './negotiation-listings-empty-state.module.scss';

interface EmptyStateProps {
  type: 'buying' | 'selling' | 'listings';
}

const NegotiationListingsEmptyState = ({ type }: EmptyStateProps) => {
  const { t: t1 } = useTranslation('common');
  const { t: t2 } = useTranslation('negotiation');
  const { sendAnalyticEvent } = useAnalyticEvents('my_listings');

  const trackClick = () => {
    sendAnalyticEvent('my_listings_empty_state');
  };

  const imageMap = {
    buying: `${Environment.assetsPath}/images/svg/mmao.svg`,
    selling: `${Environment.assetsPath}/images/svg/mmao.svg`,
    listings: `${Environment.assetsPath}/images/svg/shoe.svg`,
  };

  const titleMap = {
    buying: t1('BUYING_OFFERS.EMPTY_STATE.TITLE'),
    selling: t1('BUYING_OFFERS.EMPTY_STATE.TITLE'),
    listings: t2('NEGOTIATION_LISTING.EMPTY_STATE.LISTINGS.TITLE'),
  };

  const subtitleMap = {
    buying: t1('BUYING_OFFERS.EMPTY_STATE.SUBTITLE'),
    selling: t2('NEGOTIATION_LISTING.EMPTY_STATE.SELLING_OFFERS.SUBTITLE'),
    listings: t2('NEGOTIATION_LISTING.EMPTY_STATE.LISTINGS.SUBTITLE'),
  };

  const hrefMap = {
    buying: '/',
    selling: '/sell-clothes-online',
    listings: '/sell-clothes-online',
  };

  const ctaTextMap = {
    buying: t1('BUYING_OFFERS.EMPTY_STATE.CTA_SHOPPING'),
    selling: t2('NEGOTIATION_LISTING.EMPTY_STATE.START_SELLING'),
    listings: t2('NEGOTIATION_LISTING.EMPTY_STATE.START_SELLING'),
  };

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyState__icon}>
        <img
          loading="lazy"
          width={80}
          height={80}
          src={imageMap[type]}
          alt=""
          aria-hidden="true"
        />
      </div>
      <div
        className={styles.emptyState__title}
        data-cy={`empty_state_${type}_headline`}
      >
        {titleMap[type]}
      </div>
      <div
        className={styles.emptyState__subtitle}
        data-cy={`empty_state_${type}_subheadline`}
      >
        {subtitleMap[type]}
      </div>
      <div className={styles.emptyState__btn}>
        <Link
          href={hrefMap[type]}
          className={'vc-btn vc-btn--rounded-secondary vc-btn--medium'}
          data-cy={`empty_state_${type}_cta`}
          onClick={type === 'listings' && trackClick}
        >
          {ctaTextMap[type]}
        </Link>
      </div>
    </div>
  );
};

export default NegotiationListingsEmptyState;
